<template>
  <div>
    <Dialog
      :key="formKey"
      :visible.sync="dashboardFormDialog1"
      :style="{
        width: '100%',
        maxWidth: '1600px',
        minHeight: '730px',
        overflowY: 'auto'
      }"
      header="Add user widget"
      :modal="true"
      class="p-fluid"
    >
      <div style="min-height: 580px">
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="custName">Widget Name</label>
            <Dropdown
              :showClear="true"
              v-model="widget"
              :options="dashboardWidgets"
              optionLabel="widgetDescription"
              dataKey="id"
              placeholder="Select widget"
              :disabled="disabledArr.includes('widget')"
            />
            <small class="p-invalid" v-if="submitted && !(widget && widget.id)"
              >Widget is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="widgetTitle">Title</label>
            <InputText
              id="widgetTitle"
              placeholder=""
              v-model.trim="widgetTitle"
              required="true"
              :disabled="disabledArr.includes('widgetTitle')"
              :class="{ 'p-invalid': submitted && !widgetTitle }"
            >
            </InputText>
            <small class="p-invalid" v-if="submitted && !widgetTitle"
              >Widget Title is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="screenPos">Position</label>
            <InputNumber
              id="screenPos"
              v-model.trim="screenPos"
              required="true"
              placeholder="Please enter a number"
              :disabled="disabledArr.includes('screenPos')"
              :class="{ 'p-invalid': submitted && !screenPos }"
            >
            </InputNumber>
            <small class="p-invalid" v-if="submitted && !screenPos"
              >Screen Position is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid" v-if="widget">
          <div class="p-field p-col">
            <label for="screenPos">Parameter 1</label>
            <InputText
              id="widgetParam1"
              placeholder=""
              v-model.trim="widget.widgetParam1"
              required="false"
              :disabled="true"
            >
            </InputText>
          </div>
          <div class="p-field p-col">
            <label for="screenPos">Param Value 1</label>
            <MultiSelect
              v-if="widget && widget.widgetParam1 === 'BRANCH'"
              v-model="ParamVal1"
              :options="branches"
              optionLabel="branchName"
              dataKey="id"
              placeholder="Select Param Value 1"
              :disabled="disabledArr.includes('ParamVal1')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal1 && ParamVal1.length) &&
                  widget.widgetParam1
              }"
            />
            <MultiSelect
              v-if="widget && widget.widgetParam1 === 'REGION'"
              v-model="ParamVal1"
              :options="regions"
              optionLabel="regionName"
              dataKey="id"
              placeholder="Select Param Value 1"
              :disabled="disabledArr.includes('ParamVal1')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal1 && ParamVal1.length) &&
                  widget.widgetParam1
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam1 === 'PROD_TYPE'"
              v-model="ParamVal1"
              :options="productTypes"
              optionLabel="productTypeName"
              dataKey="id"
              placeholder="Select Param Value 1"
              :disabled="disabledArr.includes('ParamVal1')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal1 && ParamVal1.length) &&
                  widget.widgetParam1
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam1 === 'SALES_EXEC'"
              v-model="ParamVal1"
              :options="salesExecs"
              optionLabel="salesExecName"
              dataKey="id"
              placeholder="Select Param Value 1"
              :disabled="disabledArr.includes('ParamVal1')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal1 && ParamVal1.length) &&
                  widget.widgetParam1
              }"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  !(ParamVal1 && ParamVal1.length) &&
                  widget.widgetParam1
              "
              >Param1 is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid" v-if="widget">
          <div class="p-field p-col">
            <label for="screenPos">Parameter 2</label>
            <InputText
              id="widgetParam2"
              placeholder=""
              v-model.trim="widget.widgetParam2"
              required="false"
              :disabled="true"
            >
            </InputText>
          </div>
          <div class="p-field p-col">
            <label for="screenPos">Param Value 2</label>
            <MultiSelect
              v-if="widget && widget.widgetParam2 === 'BRANCH'"
              v-model="ParamVal2"
              :options="branches"
              optionLabel="branchName"
              dataKey="id"
              placeholder="Select Param Value 2"
              :disabled="disabledArr.includes('ParamVal2')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal2 && ParamVal2.length) &&
                  widget.widgetParam2
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam2 === 'REGION'"
              v-model="ParamVal2"
              :options="regions"
              optionLabel="regionName"
              dataKey="id"
              placeholder="Select Param Value 2"
              :disabled="disabledArr.includes('ParamVal2')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal2 && ParamVal2.length) &&
                  widget.widgetParam2
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam2 === 'PROD_TYPE'"
              v-model="ParamVal2"
              :options="productTypes"
              optionLabel="productTypeName"
              dataKey="id"
              placeholder="Select Param Value 2"
              :disabled="disabledArr.includes('ParamVal2')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal2 && ParamVal2.length) &&
                  widget.widgetParam2
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam2 === 'SALES_EXEC'"
              v-model="ParamVal2"
              :options="salesExecs"
              optionLabel="salesExecName"
              dataKey="id"
              placeholder="Select Param Value 2"
              :disabled="disabledArr.includes('ParamVal2')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal2 && ParamVal2.length) &&
                  widget.widgetParam2
              }"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  !(ParamVal2 && ParamVal2.length) &&
                  widget.widgetParam2
              "
              >Param2 is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid" v-if="widget">
          <div class="p-field p-col">
            <label for="screenPos">Parameter 3</label>
            <InputText
              id="widgetParam3"
              placeholder=""
              v-model.trim="widget.widgetParam3"
              required="false"
              :disabled="true"
            >
            </InputText>
          </div>
          <div class="p-field p-col">
            <label for="screenPos">Param Value 3</label>
            <MultiSelect
              v-if="widget && widget.widgetParam3 === 'BRANCH'"
              v-model="ParamVal3"
              :options="branches"
              optionLabel="branchName"
              dataKey="id"
              placeholder="Select Param Value 3"
              :disabled="disabledArr.includes('ParamVal3')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal3 && ParamVal3.length) &&
                  widget.widgetParam3
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam3 === 'REGION'"
              v-model="ParamVal3"
              :options="regions"
              optionLabel="regionName"
              dataKey="id"
              placeholder="Select Param Value 3"
              :disabled="disabledArr.includes('ParamVal3')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal3 && ParamVal3.length) &&
                  widget.widgetParam3
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam3 === 'PROD_TYPE'"
              v-model="ParamVal3"
              :options="productTypes"
              optionLabel="productTypeName"
              dataKey="id"
              placeholder="Select Param Value 3"
              :disabled="disabledArr.includes('ParamVal3')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal3 && ParamVal3.length) &&
                  widget.widgetParam3
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam3 === 'SALES_EXEC'"
              v-model="ParamVal3"
              :options="salesExecs"
              optionLabel="salesExecName"
              dataKey="id"
              placeholder="Select Param Value 3"
              :disabled="disabledArr.includes('ParamVal3')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal3 && ParamVal3.length) &&
                  widget.widgetParam3
              }"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  !(ParamVal3 && ParamVal3.length) &&
                  widget.widgetParam3
              "
              >Param3 is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid" v-if="widget">
          <div class="p-field p-col">
            <label for="screenPos">Parameter 4</label>
            <InputText
              id="widgetParam4"
              placeholder=""
              v-model.trim="widget.widgetParam4"
              required="false"
              :disabled="true"
            >
            </InputText>
          </div>
          <div class="p-field p-col">
            <label for="screenPos">Param Value 4</label>
            <MultiSelect
              v-if="widget && widget.widgetParam4 === 'BRANCH'"
              v-model="ParamVal4"
              :options="branches"
              optionLabel="branchName"
              dataKey="id"
              placeholder="Select Param Value 4"
              :disabled="disabledArr.includes('ParamVal4')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal4 && ParamVal4.length) &&
                  widget.widgetParam4
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam4 === 'REGION'"
              v-model="ParamVal4"
              :options="regions"
              optionLabel="regionName"
              dataKey="id"
              placeholder="Select Param Value 4"
              :disabled="disabledArr.includes('ParamVal4')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal4 && ParamVal4.length) &&
                  widget.widgetParam4
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam4 === 'PROD_TYPE'"
              v-model="ParamVal4"
              :options="productTypes"
              optionLabel="productTypeName"
              dataKey="id"
              placeholder="Select Param Value 4"
              :disabled="disabledArr.includes('ParamVal4')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal4 && ParamVal4.length) &&
                  widget.widgetParam4
              }"
            />
            <MultiSelect
              v-else-if="widget && widget.widgetParam4 === 'SALES_EXEC'"
              v-model="ParamVal4"
              :options="salesExecs"
              optionLabel="salesExecName"
              dataKey="id"
              placeholder="Select Param Value 4"
              :disabled="disabledArr.includes('ParamVal4')"
              :class="{
                'p-invalid':
                  submitted &&
                  !(ParamVal4 && ParamVal4.length) &&
                  widget.widgetParam4
              }"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  !(ParamVal4 && ParamVal4.length) &&
                  widget.widgetParam4
              "
              >Param4 is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="option">Active?</label>
            <SelectButton
              v-model="activeOption"
              :options="activeOptions"
              optionLabel="name"
            />
          </div>
          <div class="p-field p-col">
            <label for="option">Choose Link</label>
            <SelectButton
              v-model="option"
              :options="options"
              optionLabel="name"
              id="option"
            />
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col" v-if="option && option.value === 'report'">
            <label for="custName">Choose Report</label>
            <Dropdown
              :showClear="true"
              v-model="report"
              :options="reports"
              optionLabel="reportName"
              dataKey="id"
              placeholder="Select Report"
              :disabled="disabledArr.includes('report')"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  option &&
                  option.value === 'report' &&
                  !(report && report.id)
              "
              >Report is required.</small
            >
          </div>
          <div
            class="p-field p-col"
            v-else-if="option && option.value === 'view'"
          >
            <label for="custName">Choose View</label>
            <Dropdown
              :showClear="true"
              v-model="dbView"
              :options="dbViews"
              optionLabel="viewName"
              dataKey="id"
              placeholder="Select View"
              :disabled="disabledArr.includes('dbView')"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  option &&
                  option.value === 'view' &&
                  !(dbView && dbView.id)
              "
              >View is required.</small
            >
          </div>
          <div class="p-field p-col" v-else></div>
          <div class="p-field p-col">
            <div v-if="dbView && dbView.id">
              <ProgressSpinner
                v-if="userViewFiltersRequesting"
                style="width:100%; height:25px;"
                strokeWidth="5"
                fill="#EEEEEE"
                animationDuration=".5s"
              />
              <div v-else>
                <label for="savedFilter">Saved Filter</label>
                <Dropdown
                  :showClear="true"
                  v-model="savedFilter"
                  :options="userViedFilters"
                  optionLabel="filterName"
                  dataKey="id"
                  placeholder="Select View"
                  :disabled="disabledArr.includes('savedFilter')"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !(savedFilter && savedFilter.id)"
                  >Saved Filter is required.</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideDialog()"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveDashboard()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import UserService from "@/service/UserService";
import FiltersService from "@/service/FiltersSerice";
import SettingService from "@/service/SettingService";
import OpportunityService from "@/service/OpportunityService";
import CustomerService from "@/service/CustomerService";

import { widgetRequest } from "../sendRequest";

export default {
  created() {
    this.getDashboardWidgets();
    this.getDBViews();
    this.setupComponent();

    this.getAllBranches();
    this.getAllRegions();
    this.getAllProductTypes();
    this.getAllSalesExec();
  },
  props: [
    "widgetFormDialog",
    "widgetToEdit",
    "disabledArr",
    "resetForm",
    "refreshForm",
    "user"
  ],
  data: () => ({
    userService: new UserService(),
    filterService: new FiltersService(),
    settingService: new SettingService(),
    opportunityService: new OpportunityService(),
    customerService: new CustomerService(),
    dashboardWidgets: [],
    dbViews: [],
    userViedFilters: [],

    userViewFiltersRequesting: false,
    sendingRequest: false,
    formKey1: 0,
    submitted: false,
    widget: {},
    widgetTitle: "",
    screenPos: null,
    ParamVal1: [],
    ParamVal2: [],
    ParamVal3: [],
    ParamVal4: [],
    dbView: {},
    savedFilter: {},
    report: {},
    reports: [],
    option: { name: "Nothing", value: "nothing" },
    options: [
      { name: "Nothing", value: "nothing" },
      { name: "View", value: "view" },
      { name: "Report", value: "report" }
    ],
    activeOption: { name: "Active", value: true },
    activeOptions: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ],
    requestingBranches: false,
    branches: [],
    requestingRegions: false,
    regions: [],
    requestingProductTypes: false,
    productTypes: [],
    requestingSalesExec: false,
    salesExecs: []
  }),
  computed: {
    profile() {
      return this.$store.getters["auth/getMyProfile"];
    },
    dashboardFormDialog1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.widgetFormDialog;
      }
    },
    formKey: {
      set() {
        this.formKey1++;
      },
      get() {
        return "dashboardFormKey" + this.formKey1;
      }
    }
  },
  watch: {
    refreshForm() {
      this.formKey++;
      this.setupComponent();
    },
    resetForm() {
      this.sendingRequest = false;
      this.formKey1 = 0;
      this.submitted = false;
      this.widget = {};
      this.widgetTitle = "";
      this.screenPos = null;
      this.ParamVal1 = [];
      this.ParamVal2 = [];
      this.ParamVal3 = [];
      this.ParamVal4 = [];
      this.dbView = {};
      this.userViewFiltersRequesting = false;
      this.savedFilter = {};

      if (
        !(this.reports && this.reports.length) &&
        this.$store.getters["reports/getAllReports"]
      ) {
        this.reports = this.$store.getters["reports/getAllReports"];
      }
    },
    dbView(val) {
      if (val && val.id) {
        this.getUserViewFiltersbyUser();
      }
    },
    option(val) {
      if (val && val.value === "report") {
        this.dbView = {};
        this.savedFilter = {};
      } else if (val && val.value === "view") {
        this.report = {};
      } else {
        this.dbView = {};
        this.savedFilter = {};
        this.report = {};
      }
    },
    ParamVal1(val) {
      this.setParamValues("ParamVal1", val);
    },
    ParamVal2(val) {
      this.setParamValues("ParamVal2", val);
    },
    ParamVal3(val) {
      this.setParamValues("ParamVal3", val);
    },
    ParamVal4(val) {
      this.setParamValues("ParamVal4", val);
    },
    branches(val) {
      if (val && val.length) {
        this.setupParams();
      }
    },
    regions(val) {
      if (val && val.length) {
        this.setupParams();
      }
    },
    productTypes(val) {
      if (val && val.length) {
        this.setupParams();
      }
    },
    salesExecs(val) {
      if (val && val.length) {
        this.setupParams();
      }
    }
  },
  methods: {
    setupComponent() {
      if (this.widgetToEdit && this.widgetToEdit.widget) {
        this.widget = this.widgetToEdit.widget;
        this.widgetTitle = this.widgetToEdit.widgetTitle;
        this.screenPos = parseInt(this.widgetToEdit.screenPos);

        if (this.widgetToEdit.active) {
          this.activeOption = { name: "Active", value: true };
        } else {
          this.activeOption = { name: "Inactive", value: false };
        }

        this.setupParams();
      }
    },
    setupParams() {
      if (this.widgetToEdit && this.widget) {
        if (this.widgetToEdit.paramVal1) {
          this.setupParamVals(1, this.widgetToEdit.paramVal1);
        }
        if (this.widgetToEdit.paramVal2) {
          this.setupParamVals(2, this.widgetToEdit.paramVal2);
        }
        if (this.widgetToEdit.paramVal3) {
          this.setupParamVals(3, this.widgetToEdit.paramVal3);
        }
        if (this.widgetToEdit.paramVal4) {
          this.setupParamVals(4, this.widgetToEdit.paramVal4);
        }
      }
    },
    setupParamVals(paramNo, val) {
      let items = val.split(",");
      if (items && items.length) {
        items = items.map(item => {
          if (item) {
            return parseInt(item.trim());
          }
        });
      }
      if (
        this.widget[`widgetParam${paramNo}`] === "BRANCH" &&
        this.branches &&
        this.branches.length
      ) {
        this[`ParamVal${paramNo}`] = this.branches.filter(branch => {
          let index = items.findIndex(item => item === branch.id);
          if (index >= 0) {
            return true;
          } else {
            return false;
          }
        });
      } else if (
        this.widget[`widgetParam${paramNo}`] === "REGION" &&
        this.regions &&
        this.regions.length
      ) {
        this[`ParamVal${paramNo}`] = this.regions.filter(region => {
          let index = items.findIndex(item => item === region.id);
          if (index >= 0) {
            return true;
          } else {
            return false;
          }
        });
      } else if (
        this.widget[`widgetParam${paramNo}`] === "PROD_TYPE" &&
        this.productTypes &&
        this.productTypes.length
      ) {
        this[`ParamVal${paramNo}`] = this.productTypes.filter(type => {
          let index = items.findIndex(item => item === type.id);
          if (index >= 0) {
            return true;
          } else {
            return false;
          }
        });
      } else if (
        this.widget[`widgetParam${paramNo}`] === "SALES_EXEC" &&
        this.salesExecs &&
        this.salesExecs.length
      ) {
        this[`ParamVal${paramNo}`] = this.salesExecs.filter(type => {
          let index = items.findIndex(item => item === type.id);
          if (index >= 0) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
    hideDialog() {
      this.$emit("close");
    },
    saveDashboard() {
      this.submitted = true;

      widgetRequest(this, "WidgetForm.vue");
    },
    getDashboardWidgets() {
      this.userService
        .getDashboardWidgets()
        .then(data => {
          this.dashboardWidgets = data.filter(a => a.active);
        })
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dashboardWidgets"'
          });
        });
    },
    getDBViews() {
      this.filterService
        .getDBViews()
        .then(data => {
          this.dbViews = data;
        })
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViews"'
          });
        });
    },
    getUserViewFiltersbyUser() {
      if (this.profile && this.dbView) {
        this.userViewFiltersRequesting = true;

        this.filterService
          .getUserViewFiltersbyUser(this.dbView.id, this.profile.id)
          .then(data => {
            this.userViewFiltersRequesting = false;

            this.userViedFilters = data;
          })
          .catch(error => {
            this.userViewFiltersRequesting = false;

            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "userViewFiltersbyUser/{viewId}/{userId}"'
            });
          });
      }
    },
    setParamValues(param, val) {
      if (val && val.length) {
        if (val[val.length - 1].id === -1 || val[val.length - 1].id === 0) {
          if (val.length > 1) {
            this[param] = [val[val.length - 1]];
          }
        } else if (val[val.length - 1].id > 0) {
          let index = val.findIndex(a => a.id === -1);
          if (index < 0) {
            index = val.findIndex(a => a.id === 0);
          }
          if (index >= 0) {
            this[param] = val.filter(a => a.id > 0);
          }
        }
      }
    },
    getAllBranches() {
      this.requestingBranches = true;
      this.settingService
        .getAllBranches()
        .then(data => {
          this.requestingBranches = false;
          this.branches = [
            { id: -1, branchName: "ALL" },
            { id: 0, branchName: "Based on User Record" },
            ...data
          ];
        })
        .catch(err => {
          this.requestingBranches = false;

          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "mbpBranches"'
          });
        });
    },
    getAllRegions() {
      this.requestingRegions = true;
      this.settingService
        .getAllRegions()
        .then(data => {
          this.requestingRegions = false;
          this.regions = [
            { id: -1, regionName: "ALL" },
            { id: 0, regionName: "Based on User Record" },
            ...data
          ];
        })
        .catch(err => {
          this.requestingRegions = false;

          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "regions"'
          });
        });
    },
    getAllProductTypes() {
      this.requestingProductTypes = true;
      this.opportunityService
        .getAllProductTypes()
        .then(data => {
          this.requestingProductTypes = false;
          this.productTypes = [
            { id: -1, productTypeName: "ALL" },
            { id: 0, productTypeName: "Based on User Record" },
            ...data
          ];
        })
        .catch(err => {
          this.requestingProductTypes = false;

          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "productTypes"'
          });
        });
    },
    getAllSalesExec() {
      this.requestingSalesExec = true;
      this.customerService
        .getAllSalesExecs()
        .then(data => {
          this.requestingSalesExec = false;
          this.salesExecs = [
            { id: -1, salesExecName: "ALL" },
            { id: 0, salesExecName: "Based on User Record" },
            ...data
          ];
        })
        .catch(err => {
          this.requestingSalesExec = false;

          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "salesExecs"'
          });
        });
    }
  }
};
</script>

<style></style>
